export default __webpack_public_path__ + "static/Fusion@2x-cc60978bdae500953137eab70ba30a7a.jpg";